/**
 * We need to initialize a couple of features on the enquiry form
 *     - Toggle attribute on radio group
 *     - Toggle visibility of some Elements
 */
export default function initEnquiryForm() {
  const enquiryForm = document.querySelector('.enquiry__form');
  if (!enquiryForm) return;

  const enquiryRadiosContainers = document.querySelectorAll('.enquiry__radios-container');

  if (enquiryRadiosContainers) {
    enquiryRadiosContainers.forEach((enquiryRadiosContainer) => {
      initEnquiryRadiosContainer(enquiryRadiosContainer);
    });
  }

  updateInpagePrice();
  selectSpanStartDateOnEmptyDatepickerOpen();
}

/**
 * Get required elements and add Event listeners to the radios inside the container
 *
 * @param enquiryRadiosContainer
 */
function initEnquiryRadiosContainer(enquiryRadiosContainer) {
  const radioGroups = enquiryRadiosContainer.querySelectorAll('.radio-group');
  if(!radioGroups) return;

  radioGroups.forEach((radioGroup) => {
    radioGroup.radio = radioGroup.querySelector('.radio');
    radioGroup.radio.toggleTarget = radioGroup.radio.getAttribute('enquiry-radio-target');
    radioGroup.radio.addEventListener('click', () => {
      updateRadioGroupsUI(radioGroups);
      if (radioGroup.radio.toggleTarget) {
        toggleEnquiryTarget(radioGroup.radio)
      }
    });
    // Allow for click on the whole group and not just the radio and the label
    radioGroup.addEventListener('click', () => radioGroup.radio.click());

    if (radioGroup.radio.checked) {
      toggleEnquiryTarget(radioGroup.radio)
    }
  });
}

/**
 * Toggle 'has-checked-attribute' on all radio groups according to radio states
 *
 * @param radioGroups
 */
function updateRadioGroupsUI(radioGroups) {
  radioGroups.forEach((radioGroup) => {
    radioGroup.radio.checked
      ? radioGroup.setAttribute('has-checked-radio', '')
      : radioGroup.removeAttribute('has-checked-radio');
  });
}

/**
 * Toggle visibility of radio targets
 * (this is used to show / hide some form elements accordion to the state of some other radio input
 * and to add / remove validation of the hidden form inputs)
 *
 * @param radio
 */
function toggleEnquiryTarget(radio) {
  const radioTarget = document.getElementById(radio.toggleTarget);
  if (!radioTarget) return;

  const radioTargetInputs = radioTarget.querySelectorAll('.form__input')

  if (radio.getAttribute('enquiry-radio-target-state') === "true") {
    radioTarget.setAttribute('visible', '')
    radioTargetInputs.forEach((radioTargetInput) => {
      radioTargetInput.removeAttribute('disabled');
    })
  } else {
    radioTarget.removeAttribute('visible');
    radioTargetInputs.forEach((radioTargetInput) => {
      radioTargetInput.setAttribute('disabled', '');
    })
  }

  requestAnimationFrame(() => {
    radioTarget.dispatchEvent(new CustomEvent('toujou-form-update-inputs-to-validate', {
      bubbles: true,
      composed: true
    }))
  })
}

function updateInpagePrice() {
  const dateFromField = document.querySelector('.date-range--from');
  const classSpansField =  document.querySelector('.enquiry__class-spans');
  const inpagePrice = document.querySelector('.booking-sticky-info__price-amount');

  if (null === dateFromField || null === classSpansField || null === inpagePrice) {
    return;
  }

  const callback = () => {
    const dateFrom = dateFromField.value;
    /** @type Array */
    const spans = JSON.parse(classSpansField.value);
    const selectedSpan = spans.find(span => dateFrom >= span.dateFrom && dateFrom <= span.dateTo);

    if (selectedSpan) {
      inpagePrice.textContent = `${selectedSpan.price * selectedSpan.minPerson} ${inpagePrice.dataset.currency}`;
    } else {
      inpagePrice.textContent = inpagePrice.dataset.outOfRangeText;
    }
  }

  document.querySelector('.date-range--facade').addEventListener('change', callback);

  // do not calculate price on initial call
  if (dateFromField.value !== '') {
    callback();
  }
}

function selectSpanStartDateOnEmptyDatepickerOpen() {
  const datepicker = document.querySelector('[data-span-date-from]');

  if (null === datepicker) {
    return;
  }

  datepicker.flatpickr.config.onOpen.push(function(selectedDates, dateStr, instance) {
    if (dateStr === '') {
      const date = instance.parseDate(datepicker.dataset.spanDateFrom, 'Y-m-d');
      instance.setDate([date, date]);
    }
  });
}
